@if (products?.length) {
  @for (product of products; track product.code) {
    <mkp-product-card
      [isLoading]="product.code === isProductLoading"
      [isReadMode]="isReadMode"
      [isCollapsed]="isCollapsed"
      [product]="product"
      [platforms]="platforms"
      [benefits]="benefits"
      [activePlatformGroup]="activePlatformGroup"
      [discountLineThrough]="discountLineThrough"
      (handleSelectedProduct)="handleSelectedProduct.emit($event)"
    />
  }
} @else {
  <mkp-cards-skeleton />
}
